module.exports = __webpack_public_path__ + "static/capital-one-648491f491f66c99603ca4361b6932b6.png";